module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "default_right.a801c0cc.svg";